import { z } from 'zod';

import { entityIdentifierSchema } from '~/shared/data-contract/chat/chat-entity';
import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from '~/shared/data-contract/chat/chat-ids';
import { contextRefreshActionSchema } from '~/shared/data-contract/chat/context-refresh-event';

export const contextRefreshPayloadSchema = z.object({
    action: contextRefreshActionSchema,
    entities: z.array(entityIdentifierSchema).min(1),
});

export type ContextRefreshPayload = z.infer<typeof contextRefreshPayloadSchema>;

/** The legacy SSE `context-refresh` event; the AG-UI chat carries the payload as a `cobrainer.context-refresh` value. */
export const contextRefreshEnvelopeSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('context-refresh'),
    messageId: chatMessageIdSchema,
    payload: contextRefreshPayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type ContextRefreshEnvelope = z.infer<typeof contextRefreshEnvelopeSchema>;
